export default __webpack_public_path__ + "static/media/Dot.7ae19044.svg";